import { Navigate, useLocation, useParams } from "react-router-dom";

/** Redirects an old address to a new one, keeping the query string (campaign parameters) and hash. */
export default function LegacyRedirect({ to }: { to: string }) {
  const { search, hash } = useLocation();
  const params = useParams();
  const path = to.replace(/:(\w+)/g, (_, k: string) => encodeURIComponent(params[k] ?? ""));
  return <Navigate to={`${path}${search}${hash}`} replace />;
}
